/* =Masonry js
 ----------------------------------------------- */
(function($) {

	// Default masonry grid
	const masonry = $('.masonry');
	if (masonry.length > 0) {
    // Initialise masonry
		masonry.prepend('<div class="masonry-column"></div><div class="masonry-gutter"></div>');
		masonry.masonry({
			itemSelector: '.masonry-item',
			columnWidth: '.masonry-column',
			gutter: '.masonry-gutter',
			percentPosition: true
		});

    // Trigger updated when images are ready
    masonry.imagesLoaded(() => {
      masonry.masonry('layout');
    });
	}

})(jQuery);
